import { TextField } from '@mui/material'
import { GridRenderEditCellParams } from '@mui/x-data-grid-premium'

const MultilineEditInput = (props: GridRenderEditCellParams) => {
  return (
    <TextField
      multiline
      fullWidth
      value={props.value ?? ''}
      onChange={event => {
        props.api.setEditCellValue({ id: props.id, field: props.field, value: event.target.value })
      }}
      autoFocus
      rows={2}
      variant="standard"
      slotProps={{
        input: {
          disableUnderline: true,
          sx: {
            // border: 'none',
            color: 'inherit',
            // font: 'inherit',
            fontSize: 'inherit',
            p: 0,

            height: '100%',
            display: 'flex',
            alignItems: 'center',
            '& textarea': {
              height: '100% !important',
              resize: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              pt: 1.5,
              pl: 1,
              pr: 1,
            },
          },
        },
      }}
      sx={{
        // p: 0,
        // color: 'inherit',
        // font: 'inherit',
        // fontSize: 'inherit',
        display: 'flex',
        flex: 1,

        height: '100%',
        '& .MuiInputBase-root': {
          height: '100%',
        },
      }}
    />
  )
}

export default MultilineEditInput
